import styled from 'styled-components';
import { FontAddiWeightRegular } from '@addi/foundation/dist/web/fonts';
import { LayoutAddiScreenMobileLargeMax } from '@addi/foundation/dist/web/layout';
import { SizeAddiFontSmall, SizeAddiFontXSmall, SizeAddiFontXxSmall, } from '@addi/foundation/dist/web/sizes';
import { ColorAddiCompFiveLighten3, ColorAddiGrayBase } from '@addi/foundation/dist/web/colors';
import { Header3, Paragraph } from '../../components/typographies';
import { PrimaryButton } from '../button';
import { transformRGBtoRGBA } from '../../utils';
export const BannerContainer = styled.div `
  display: flex;
  background-color: ${transformRGBtoRGBA(ColorAddiCompFiveLighten3, 0.4)};
  border-radius: 8px;
  flex-direction: column;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    flex-direction: row;
    min-height: 113px;
  }
`;
export const IconImage = styled.div `
  display: none;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    display: block;
    width: 130px;
    height: auto;
    min-height: 100%;
    background-image: url(${(props) => props.backgroundImage});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
`;
export const MainContent = styled.div `
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: left;
  flex-direction: column;
  margin: 16px;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    margin: 0 39px 0 20px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;
export const TextContent = styled.div `
  padding: 0;
`;
export const TitleBanner = styled(Header3) `
  margin: 0;
  margin-bottom: 10px;
  font-size: ${SizeAddiFontXSmall};
  font-weight: ${FontAddiWeightRegular};
  line-height: 14.84px;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    margin-bottom: 16.75px;
    font-size: 28px;
    line-height: 30.8px;
  }
`;
export const SubTitleBanner = styled(Paragraph) `
  margin: 0;
  margin-bottom: 8px;
  font-weight: ${FontAddiWeightRegular};
  color: ${ColorAddiGrayBase};
  font-size: ${SizeAddiFontXxSmall};
  line-height: 16.32px;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    margin-bottom: 0;
    font-size: ${SizeAddiFontSmall};
    line-height: 23.68px;
  }
`;
export const BannerBtn = styled(PrimaryButton) `
  width: 100%;

  @media (min-width: ${LayoutAddiScreenMobileLargeMax}) {
    width: auto;
  }
`;
//# sourceMappingURL=banner-cupo.styles.js.map